import Controller from "./supplySourcePaymentMethods.controller";
import template from "./supplySourcePaymentMethods.html";

const supplySourcePaymentMethods = {
  template,
  controller: Controller,
  bindings: {
    cityId: "<",
    supplySourceId: "<",
    supplySource: "@",
    resourceName: "@",
    resourceGetMethod: "@",
    resourceSubmitMethod: "@",
  },
};

export default supplySourcePaymentMethods;



// WEBPACK FOOTER //
// ./src/components/supplySourcePaymentMethods/supplySourcePaymentMethods.component.js